<template>
    <div>
        <br><br><br>
        <v-app class="bg-transparent">
            <div class="container-fluid pl-0 ">
                <v-row>
                    <v-col cols="3">
                        <v-card class="rounded-lg px-5 py-2 " style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);">
                            <v-card-title class="color-default font-weight-bold">Informations</v-card-title>
                            <v-divider class="mx-4 my-0"></v-divider>

                            <!-- Company Logo -->
                            <!-- <div class="px-4 mt-5">
                                 <svg width="190" height="190" viewBox="0 0 190 190">
                                    <rect x="0.970703" y="0.416992" width="188.889" height="188.889" rx="8" style="fill:#dbdee0" />
                                    <text x="48" y="100" fill="#757778" style="font-weight: 700;font-size:20px;opacity:80%">No Image</text>
                                </svg>
                            </div> -->
                            
                            <div>
                                <v-card-title class="font-weight-bold mt-1">{{demo.company}}</v-card-title>
                                <v-card-subtitle>{{demo.name}}</v-card-subtitle>
                            </div>
                            <v-divider class="mx-4 mt-0"></v-divider>
                            <!-- <div class="hide-scroll" style=" height:37vh; overflow-y:auto !important"> -->
                            <div class="hide-scroll" style=" height:550px; overflow-y:auto !important">
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Phone Number</span> <br>
                                    <span>{{demo.phone}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Email Address</span> <br>
                                    <span>{{demo.email}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Country</span> <br>
                                    <span>{{demo.country}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Website</span> <br>
                                    <span>{{demo.company_url}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Software</span> <br>
                                    <span v-if="demo.lead_for==1">TheStaffer</span>
                                    <span v-else>LinenTech</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Request Date</span> <br>
                                    <span>{{demo.created_at | formatDate}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Implementation</span> <br>
                                    <span>{{demo.implement_date}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Hear About Us </span> <br>
                                    <span>{{demo.hear_about}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Services</span> <br>
                                    <span class="rounded pill px-3 mb-1" style=" background-color: #ebf7df;color: #66b34d;border: 1px solid #66b34d;" v-if="demo.rental == 1">Linen Rental</span>
                                    <span class="rounded pill px-3 ml-1 mb-1" style=" background-color: #ebf7df;color: #66b34d;border: 1px solid #66b34d;" v-if="demo.dry_cleaning == 1">Dry Cleaning</span>
                                    <br v-if="demo.cog == 1">
                                    <span class="rounded pill px-3" style=" background-color: #ebf7df;color: #66b34d;border: 1px solid #66b34d;" v-if="demo.cog == 1">Customer Owned Goods</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Industries</span> <br>
                                    <span>-</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Address</span> <br>
                                    <span>-</span>
                                </v-card-text>
                                <v-card-text class="pb-0" v-if="demo.status=='3'">
                                    <span class="color-default font-weight-bold">Rejection Reason</span> <br>
                                    <span>{{demo.reject_msg}}</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Weight To Process</span> <br>
                                    <span>-</span>
                                </v-card-text>
                                <v-card-text class="pb-0">
                                    <span class="color-default font-weight-bold">Key Challenges</span> <br>
                                    <span>-</span>
                                </v-card-text>

                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="4" >
                        <v-card class="rounded-lg px-5 py-2" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);">
                            <v-card-title class="color-default font-weight-bold">Prospection Questions</v-card-title>
                            <v-divider class="mx-4 mt-0"></v-divider>
                            <template
                                v-if="leadWithData && leadWithData.lead_questionnaires && leadWithData.lead_questionnaires.length > 0">
                                <div v-for="questionnaire in leadWithData.lead_questionnaires" :key="questionnaire.id">
                                    <p class="color-default font-weight-bold">
                                        Q . {{ questionnaire.question }}
                                    </p>
                                    <div v-for="answer in questionnaire.lead_questionnaire_answers" :key="answer.id">
                                        <div v-if="answer.answer.includes('?ques_id=')">
                                            <span class="color-default font-weight-bold">&bull;</span>
                                            {{ answer.answer.split('?ques_id=')[0] }}
                                        </div>
                                        <div v-else-if="questionnaire.type !== 'track_rental_soiled_linen_rental'">
                                            <span class="color-default font-weight-bold">&bull;</span>
                                            {{ answer.answer }}
                                        </div>
                                        <div v-else>
                                            <textarea v-model="answer.answer" rows="4" cols="50"></textarea>
                                        </div>
                                    </div>
                                    <hr>
                                </div>
                            </template>
                            <template v-else-if="leadWithData !== null">
                                <p class="text-center">No Data Found!</p>
                            </template>
                            <template v-else>
                                <p class="text-center">Loading...</p>
                            </template>
                        </v-card>
                    </v-col>
                    <v-col cols="5">
                        <v-card class="rounded-lg px-4 py-2" style="box-shadow: 0px 8px 24px rgba(38, 107, 162, 0.16);">
                            <v-row class="mx-4 my-0">
                                <v-card-title v-if="tab==1" style="padding:14px 4px;" class="color-default font-weight-bold mr-auto">Notes</v-card-title>
                                <v-card-title v-else style="padding:14px 4px;" class="color-default font-weight-bold mr-auto">Demo Notes</v-card-title>
                                <v-card-title style="padding:14px 4px;" class="">
                                    <a class="notes-tabs" v-bind:class="[ tab==1 ? 'active' : '']" @click="tabs(1)">Notes</a>
                                </v-card-title>
                                <v-card-title style="padding:14px 4px;">
                                    <a class="notes-tabs" v-bind:class="[ tab==2 ? 'active' : '']" @click="tabs(2)">Demo
                                        Notes</a>
                                </v-card-title>
                            </v-row>
                            <v-divider class="mx-4 mt-0"></v-divider>
                            <!-- <div class="hide-scroll" style="height:66.6vh; overflow-y:auto !important;"> -->
                            <div class="hide-scroll" style="height:642px; overflow-y:auto !important;">
                                <!-- Notes -->
                                <div v-if="tab==1">
                                    <div class="vtl" v-for="note in Note" :key="note.id">
                                        <div class="event">
                                            <strong class="edate">{{note.created_at | formatDate}}  </strong>
                                            <p style="white-space: break-spaces;" class="etxt">{{note.note}}</p>
                                        </div>
                                    </div>
                                    <div class="text-center" v-if="Note==''">
                                        <h4 class="my-5 py-5">No Content</h4>
                                    </div>
                                </div>
                                <!-- Demo Notes -->
                                <div v-if="tab==2">
                                    <div class="vtl" v-for="note in demoNote" :key="note.id">
                                        <div class="event">
                                            <strong class="edate">{{note.created_at | formatDate}} </strong><span v-if="note.completed==1" style="background-color: #d4f3b6;" class="text-success rounded-pill px-3  float-right">Completed</span>
                                            <p style="white-space: pre-line" class="etxt">{{note.schedule_note}}</p>
                                        </div>
                                    </div>
                                    <div class="text-center" v-if="demoNote==''">
                                        <h4 class="my-5 py-5">No Content</h4>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-app>  

    </div>
</template>

<script>
    import moment from 'moment';
    import axios from 'axios';

    Vue.filter('formatDate', function (value) {
        if (value != '0000-00-00 00:00:00' && value != null) {
            return moment(String(value)).format('MMM DD, Y LT')
        }
    });
    export default {

        data: function () {
            return {
                page: 0,
                tab: 1,
                leadId: null,
                leadWithData: null
            }
        },
        mounted() {
            this.leadId = this.$route.params.id;
            this.getLeadQuestionnaire(this.$route.params.id);
        },
        computed: {
            demo: function () {
                return this.$store.getters['users/demoRequest'];
            },
            demoNote: function () {
                return this.$store.getters['users/demoRequestNotes'];
            },
            Note: function () {
                 return this.$store.getters['users/leadNotes'];
            },
            onBoarding: function () {
                return this.$store.getters['users/onBoarding'];
            },
    },
        methods: {
            tabs(event) {
                if (event == 1) {
                    this.tab = 1;
                }
                else if (event == 2) {
                    this.tab = 2;
                }
            },
            getLeadQuestionnaire(id) {
                   const permission = {
      headers: {
        'X-Permission': 'lead_prospection_question' 
      }
    };
                axios.get(`/admin/users/get-lead-questionnaire/${id}`,permission)
                    .then((response) => {
                        this.leadWithData = response.data.leadWithData;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        },


        created: function () {
            // this.page = helpers.getPageQuery();
            this.$store.dispatch('users/getDemo', this.$route.params.id);
        },
    }

</script>
<style>
    .v-application--wrap {
        min-height: auto !important;
    }

    .v-card__title .notes-tabs {
        font-size: 16px;
        color: #575962;
        padding: 2px 16px;
    }

    .v-card__title .active {
        background-color: #48a6a6;
        color: white;
        padding: 2px 16px;
        border-radius: 4px;
    }


    /* notes timeline css below */

    /* (A) "SET" THE TIMELINE CONTAINER */
    .vtl {
        /* (A1) RELATIVE POSITION NECESSARY TO PROPERLY POSITION TIMELINE LATER */
        position: relative;
        /* (A2) RESERVE MORE SPACE TO THE LEFT FOR THE TIMELINE */
        padding: 10px 0px 10px 50px;
        /* (A3) OPTIONAL WIDTH RESTRICTION */
        max-width: 1000px;
    }

    /* (B) DRAW TIMELINE USING ::BEFORE */
    .vtl::before {
        /* (B1) DRAW THE TIMELINE */
        content: '';
        width: 3px;
        background-color: #f4f8fa;
        /* (B2) POSITION IT TO THE LEFT */
        position: absolute;
        top: 0;
        bottom: 0;
        left: 15px;
    }

    /* (C) STYLES FOR THE EVENTS */
    div.event {
        padding: 20px 30px;
        background-color: #f2f5f7;
        position: relative;
        border-radius: 6px;
        margin-bottom: 10px;
    }

    /* (D) STYLES FOR THE DATE & TEXT */
    strong.edate {
        font-size: 14px;
        font-weight: bold;
        color: #48a6a6;
    }

    p.etxt {
        margin: 10px 0 0 0;
        color: #222;
    }

    /* (E) ADD "SPEECH BUBBLE TRIANGLE" TO THE EVENTS */
    div.event::before {
        content: '';
        border: 10px solid transparent;
        border-right-color: #f2f5f7;
        border-left: 0;
        position: absolute;
        top: 20%;
        left: -10px;
    }

    /* (F) ADD A CIRCLE ON THE TIMELINE TO INDICATE AN EVENT */
    div.event::after {
        content: '';
        background: #f4f8fa;
        border: 4px solid #48a6a6;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        position: absolute;
        top: 25%;
        left: -40px;
    }



</style>